// firestore direct imports not needed after context updater is used

import { useRef, useState } from "react"

import AlertModal from "../../../components/AlertModal/AlertModal"
import PageWrapper from "../../../components/PageWrapper/PageWrapper"
import arrowLeft from "../../../assets/icons/Arrows/arrow-narrow-left.png"
import { uploadAvatarToStorage } from "../../../services/storage/storageService"
import { useAuth } from "../../../contexts/Auth/AuthContext"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

const EditProfile = () => {
  const { t } = useTranslation()
  const { user, updateUserProfile } = useAuth()
  const navigate = useNavigate()
  const [displayName, setDisplayName] = useState(user?.displayName || "")
  const [saving, setSaving] = useState(false)
  const fileInputRef = useRef(null)
  const [avatarFile, setAvatarFile] = useState(null)
  const [avatarPreviewUrl, setAvatarPreviewUrl] = useState(null)
  const [alertOpen, setAlertOpen] = useState(false)
  const [alertMsg, setAlertMsg] = useState("")

  const handleSave = async () => {
    if (!user) return
    try {
      setSaving(true)
      let avatarUrl
      if (avatarFile) {
        const uploaded = await uploadAvatarToStorage(user.uid, avatarFile)
        avatarUrl = uploaded.url
      }
      console.log({ displayName, avatarUrl })
      await updateUserProfile({ displayName, avatarUrl })
      navigate(-1)
    } catch (e) {
      console.error("Failed to update profile", e)
      setAlertMsg(
        t("profile.failedToUpdateProfile", {
          defaultValue: "Failed to update profile",
        })
      )
      setAlertOpen(true)
    } finally {
      setSaving(false)
    }
  }

  const handleAvatarChange = async (e) => {
    if (!user) return
    const file = e.target.files?.[0]
    if (!file) return
    setAvatarFile(file)
    try {
      const preview = URL.createObjectURL(file)
      setAvatarPreviewUrl(preview)
    } catch {}
  }

  return (
    <PageWrapper
      title={t("profile.title")}
      headerLeft={
        <button
          className="absolute left-0 inset-y-0 my-auto w-12 h-12 flex items-center justify-center z-10"
          onClick={() => navigate(-1)}
          aria-label="Back"
        >
          <img src={arrowLeft} alt="back" className="w-6 h-6 invert" />
        </button>
      }
      background="bg-dark-default"
    >
      {/* Avatar + Change photo button */}
      <div className="flex items-center justify-center mb-2">
        {avatarPreviewUrl ? (
          <img
            src={avatarPreviewUrl}
            alt="avatar"
            loading="lazy"
            referrerPolicy="no-referrer"
            className="w-24 h-24 rounded-full object-cover"
          />
        ) : user?.avatarUrl || user?.photoURL ? (
          <img
            src={user?.avatarUrl || user?.photoURL}
            alt="avatar"
            loading="lazy"
            referrerPolicy="no-referrer"
            className="w-24 h-24 rounded-full object-cover"
          />
        ) : (
          <div className="w-24 h-24 rounded-full bg-light-default" />
        )}
      </div>
      <div className="flex items-center justify-center mb-4">
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleAvatarChange}
        />
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          className="h-10 px-5 rounded-[12px] bg-transparent text-light-default text-[16px] font-semibold"
        >
          {t("profile.changeAvatar")}
        </button>
      </div>

      <div className="bg-light-default rounded-[16px] p-5 mb-4">
        <div className="text-[14px] text-black-t-lighten-1 mb-1">
          {t("profile.email")}
        </div>
        <div className="text-[16px] text-dark-default">
          {user?.email || "-"}
        </div>
        <div className="h-px bg-light-default my-3" />
        <div className="text-[14px] text-black-t-lighten-1 mb-1">
          {t("profile.name")}
        </div>
        <input
          className="w-full outline-none text-[16px] text-dark-default bg-light-default"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          maxLength={50}
          placeholder={t("profile.displayNamePlaceholder", {
            defaultValue: t("profile.displayNamePlaceholder", {
              defaultValue: "Your name",
            }),
          })}
        />
      </div>

      <button
        onClick={handleSave}
        disabled={
          saving ||
          ((displayName || "").trim() === (user?.displayName || "").trim() &&
            !avatarFile)
        }
        className={`w-full rounded-[16px] py-[18px] px-5 text-center text-[16px] font-bold ${
          saving ||
          ((displayName || "").trim() === (user?.displayName || "").trim() &&
            !avatarFile)
            ? "bg-light-t-lighten-1 text-dark-t-lighten-2"
            : "bg-light-default text-dark-default"
        }`}
      >
        {saving
          ? t("profile.saving", { defaultValue: "Saving…" })
          : t("common.save")}
      </button>
      {/* </div>
    </div> */}
      <AlertModal
        open={alertOpen}
        title={t("common.error", { defaultValue: "Error" })}
        message={alertMsg}
        onClose={() => setAlertOpen(false)}
      />
    </PageWrapper>
  )
}

export default EditProfile
